import { render, staticRenderFns } from "./DicionarioComponent.vue?vue&type=template&id=e99987d4&"
import script from "./DicionarioComponent.vue?vue&type=script&lang=js&"
export * from "./DicionarioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports